import React, { useState } from "react";

function PaloAltoFAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const isActive = (index) => activeIndex === index;

  const faqs = [
    {
      question: "What types of junk do you remove in Palo Alto?",
      answer:
        "We remove a wide range of items, including old furniture, appliances, mattresses, construction debris, yard waste, scrap metal, electronic waste, and more.",
    },
    {
      question: "Do you offer same-day junk removal in Palo Alto, CA?",
      answer:
        "Yes! We provide same-day service for most jobs. Just give us a call, and we’ll schedule a pickup right away.",
    },
    {
      question: "How much does junk removal in Palo Alto cost?",
      answer:
        "Pricing depends on the volume and type of items being removed. We offer free quotes with upfront pricing for complete transparency.",
    },
    {
      question: "Do you provide free estimates for junk removal?",
      answer: "Absolutely! Contact us for a free, no-obligation estimate.",
    },
    {
      question: "How can I schedule junk removal services in Palo Alto?",
      answer:
        "Simply call us or fill out our online form to book same-day or next-day service.",
    },
    {
      question: "What happens to the junk after it’s removed?",
      answer:
        "We prioritize eco-friendly disposal, recycling and donating items whenever possible.",
    },
    {
      question: "Do you remove construction debris in Palo Alto, CA?",
      answer:
        "Yes, we specialize in construction debris removal, including scrap metal, building materials, and other waste.",
    },
    {
      question: "Do you serve both residential and commercial customers?",
      answer:
        "Yes, we offer services for both residential and commercial clients, including office cleanouts and warehouse cleanups.",
    },
    {
      question: "How long does junk removal take?",
      answer:
        "Most jobs are completed in under 2 hours, depending on the amount and complexity of the junk.",
    },
    {
      question: "Can you remove just one item?",
      answer:
        "Of course! Whether it’s a single mattress, appliance, or pile of junk, we’re here to help.",
    },
    {
      question: "Do you charge extra for items like electronics or appliances?",
      answer:
        "Some items may have a small additional fee, but we always provide an upfront quote to avoid surprises.",
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept credit cards check and zal cash for your convenience.",
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion junk-faq-sec">
          {faqs.map((faq, index) => (
            <div
              className={`accordion-item ${isActive(index) ? "active" : ""}`}
              key={index}
            >
              <div
                className="accordion-item-header"
                onClick={() => handleAccordionClick(index)}
                style={{ color: isActive(index) ? "blue" : "#000" }}
              >
                <span className="accordion-item-header-title">
                  <img
                    src={
                      isActive(index)
                        ? "/assets/img/question-mark-yellow.svg"
                        : "/assets/img/_Compound Path_.png"
                    }
                    alt="default"
                    loading="lazy"
                    className="accordion-image"
                  />
                  <p>{faq.question}</p>
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    style={{ color: isActive(index) ? "#2d6bd6" : "#000" }}
                  />
                </svg>
              </div>
              <div
                className={`accordion-item-description-wrapper ${
                  isActive(index) ? "open" : ""
                }`}
                style={{ display: isActive(index) ? "block" : "none" }}
              >
                <div className="accordion-item-description">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default PaloAltoFAQs;
